import {
  SET_ADD_APP_PERMISSION,
  SET_CATEGORY_LISTING,
  SET_CHECK_APP_PERMISSION,
  SET_APPLICATION_LISTING,
  SET_APP_AREA_LISTING,
  SET_IS_CHECK_APP_PER,
  SET_ACTIVE_CATEGORY,
  SET_CHECK_CATEGORY,
  SET_ADD_CATEGORY,
  SET_APP_PERMISSION_LISTING,
  SET_APP_PERMISSION_BY_ID,
  SET_DELETE_APP_PERMISSION,
  SET_DELETE_SECURITY_ROLE,
  SET_ADD_APP_AREA,
  SET_APP_AREA_CHECK,
  SET_IS_APP_AREA_CHECK,
  SET_APP_AREA_BY_ID,
  SET_DELETE_APP_AREA,
  SET_ADD_APPLICATION,
  SET_APPLICATION_CHECK,
  SET_IS_APPLICATION_CHECK,
  SET_DELETE_CATEGORY,
  SET_CATEGORY_BY_ID,
  SET_ACTIVE_APPLICATION,
  SET_ACTIVE_APP_AREA,
  SET_APPLICATION_BY_ID,
  SET_DELETE_APPLICATION,
  SET_IS_CHECK,
  SET_USER_GRID_DATA,
  SET_USER,
  SET_USER_UPN_DATA,
  SET_SECURITY_PERMISSION_LISTING,
  SET_SECURITY_ROLE_LISTING,
  SET_ACTIVE_ROLES,
  SET_CREATE_USER,
  SET_ADD_SECURITY_ROLE,
  SET_SECURITY_ROLE_BY_ID,
  SET_USER_DIVISIONS,
  SET_USER_COST_CENTER,
  SET_CHECK_USER,
  SET_IS_USER_CHECK,
  SET_TIME_ZONE,
  SET_UPLOAD_APPLICATION_ICON
} from "./types";

const initialState = {
  categoryListingData: {},
  addAppPerVal: 0,
  checkAppPermission: true,
  applicationListingData: {},
  appAreaListingData: {},
  isCheckAppPer: false,
  activeCategoryData: {},
  checkCategory: true,
  addCategory: 0,
  appPermissionListing: {},
  isAppAreaCheck: false,
  addAppAreaVal: 0,
  checkAppArea: true,
  appPermissionById: {},
  securityRoleById: {},
  deleteAppPermission: false,
  deleteSecurityRole: false,
  appAreaById: {},
  deleteAppArea: false,
  isApplicationCheck: false,
  addApplicationVal: 0,
  checkApplication: true,
  deleteCategory: false,
  categoryById: {},
  activeApplicationData: {},
  activeAppAreaData: {},
  applicationById: {},
  deleteApplication: false,
  isCheck: true,
  userGridData: {
    count: 0,
    data: [],
  },
  securityPermissionList: {},
  securityRoleList: {},
  activeRolesData: {},
  addUserVal: 0,
  addSecurityRoleVal: 0,
  userData: {},
  userUpnData: {},
  userDivisions: [],
  costcenterDropdown: [],
  checkUser: true,
  isCheckUser: false,
  timeZone: {}
};

const reducers = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CATEGORY_LISTING:
      return {
        ...state,
        categoryListingData: action.value,
      };
    case SET_ADD_APP_PERMISSION:
      return {
        ...state,
        addAppPerVal: action.payload,
      };
    case SET_ADD_SECURITY_ROLE:
      return {
        ...state,
        addSecurityRoleVal: action.payload,
      };
    case SET_CHECK_APP_PERMISSION:
      return {
        ...state,
        checkAppPermission: action.payload,
      };
    case SET_CHECK_CATEGORY:
      return {
        ...state,
        checkCategory: action.payload,
      };
    case SET_APPLICATION_LISTING:
      return {
        ...state,
        applicationListingData: action.value,
      };
    case SET_APP_AREA_LISTING:
      return {
        ...state,
        appAreaListingData: action.value,
      };
    case SET_IS_CHECK_APP_PER:
      return {
        ...state,
        isCheckAppPer: action.value,
      };
    case SET_IS_CHECK:
      return {
        ...state,
        isCheck: action.value,
      };
    case SET_ACTIVE_CATEGORY:
      return {
        ...state,
        activeCategoryData: action.payload,
      };
    case SET_ADD_CATEGORY:
      return {
        ...state,
        addCategory: action.payload,
      };
    case SET_APP_PERMISSION_LISTING:
      return {
        ...state,
        appPermissionListing: action.payload,
      };
    case SET_APP_PERMISSION_BY_ID:
      return {
        ...state,
        appPermissionById: action.payload,
      };
    case SET_SECURITY_ROLE_BY_ID:
      return {
        ...state,
        securityRoleById: action.payload,
      };
    case SET_DELETE_APP_PERMISSION:
      return {
        ...state,
        deleteAppPermission: action.payload,
      };
    case SET_DELETE_SECURITY_ROLE:
      return {
        ...state,
        deleteSecurityRole: action.payload,
      };
    case SET_ADD_APP_AREA:
      return {
        ...state,
        addAppAreaVal: action.payload,
      };
    case SET_APP_AREA_CHECK:
      return {
        ...state,
        checkAppArea: action.payload,
      };
    case SET_IS_APP_AREA_CHECK:
      return {
        ...state,
        isAppAreaCheck: action.value,
      };
    case SET_APP_AREA_BY_ID:
      return {
        ...state,
        appAreaById: action.payload,
      };
    case SET_DELETE_APP_AREA:
      return {
        ...state,
        deleteAppArea: action.payload,
      };
    case SET_ADD_APPLICATION:
      return {
        ...state,
        addApplicationVal: action.payload,
      };
    case SET_APPLICATION_CHECK:
      return {
        ...state,
        checkApplication: action.payload,
      };
    case SET_IS_APPLICATION_CHECK:
      return {
        ...state,
        isApplicationCheck: action.value,
      };
    case SET_DELETE_CATEGORY:
      return {
        ...state,
        deleteCategory: action.payload,
      };
    case SET_CATEGORY_BY_ID:
      return {
        ...state,
        categoryById: action.payload,
      };
    case SET_ACTIVE_APPLICATION:
      return {
        ...state,
        activeApplicationData: action.payload,
      };
    case SET_ACTIVE_APP_AREA:
      return {
        ...state,
        activeAppAreaData: action.payload,
      };
    case SET_APPLICATION_BY_ID:
      return {
        ...state,
        applicationById: action.payload,
      };
    case SET_DELETE_APPLICATION:
      return {
        ...state,
        deleteApplication: action.payload,
      };
    case SET_USER_GRID_DATA:
      return {
        ...state,
        userGridData: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        userData: action.payload
      }
    case SET_USER_UPN_DATA:
      return {
        ...state,
        userUpnData: action.payload
      }
    case SET_ACTIVE_ROLES:
      return {
        ...state,
        activeRolesData: action.payload,
      };

    case SET_SECURITY_PERMISSION_LISTING:
      return {
        ...state,
        securityPermissionList: action.payload,
      };
    case SET_SECURITY_ROLE_LISTING:
      return {
        ...state,
        securityRoleList: action.payload,
      };
    case SET_CREATE_USER:
      return {
        ...state,
        addUserVal: action.payload,
      };
    case SET_USER_DIVISIONS:
      return {
        ...state,
        userDivisions: action.payload,
      };
    case SET_USER_COST_CENTER:
      return {
        ...state,
        costcenterDropdown: action.payload,
      };
    case SET_CHECK_USER:
      return {
        ...state,
        checkUser: action.payload,
      };
    case SET_IS_USER_CHECK:
      return {
        ...state,
        isUserCheck: action.value,
      };
    case SET_TIME_ZONE:
      return {
        ...state,
        timeZone: action.payload,
      };
    case SET_UPLOAD_APPLICATION_ICON:
      return {
        ...state,
        applicationIcon: action.response,
      };
    default:
      return state;
  };
}

export default reducers;
